import { useCallback, useState } from 'react';
import { deleteFeedback, getFeedbackList } from 'app/api/feedback';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from 'react-router-dom';

import { APP_CONSTANTS } from 'app/constants/app-constants';
const useFeedbackManagement = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [pageCount, setPageCount] = useState(0);
  const currentPage = 1;
  const dataPerPage = 10;
  const [totalNumber, setTotalNumber] = useState(0);

  const sectionObj = {
    sectionTitle: 'Feedback Mangement',

    searchObj: {
      keys: ['title', 'description'],
      placeholder: 'Search by Name , Description',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
        // inputChangeHandler(e);
      },
    },
    buttons: [
      {
        imgTrue: true,
        customclassName: '',
        title: 'Add Feedback',
        handleBtnClick: (e) => {
          navigate(APP_CONSTANTS.CREATE_FEEDBACK);
        },
      },
    ],
  };

  // Function to fetch data from the server based on current page and search value
  const fetchFeedbackData = useCallback(
    async (page, searchValue = '') => {
      setPageLoading(true);
      try {
        const response = await getFeedbackList(page, dataPerPage, searchValue); // Pass searchValue to API call
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.feedbackData || [];
          setFilteredData(dataArr);
          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  const callServiePublishOrUnpublishAPI = async (data) => {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteFeedback(data?.id);
      setPageLoading(false);
      if (responseObj?.responseCode === 200) {
        Toast.success('Feedback Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    } else {
      Toast.error('Failed to delete');
    }
  };

  const handleDelete = (data) => {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete '${data?.title}' feedback?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            callServiePublishOrUnpublishAPI(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  };

  function handleEdit(data) {
    navigate(`/feedback-management/edit/${data.id}`, {
      state: {
        ...data,
      },
    });
  }

  return {
    handleDelete,
    handleEdit,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    totalNumber,
    navigate,
    filteredData,
    sectionObj,
    fetchFeedbackData,
  };
};

export default useFeedbackManagement;
